import { clearableRequiredFieldsDefaultValuesPersonalDetails } from '../../../financeProviders/shared/constants/clearableRequiredDefaultValues';

/**
 * Placeholder values are initialised to empty strings so that the field will be considered invalid
 * and the panel 'incomplete' until the user chooses a non-empty option for each required input.
 */
const SELECT_PLACEHOLDER_VALUE = '';

const countryOptions = [
  {
    label: 'Select country of birth',
    value: SELECT_PLACEHOLDER_VALUE,
  },
  'Irish',
  'Northern Irish',
  'Afghan',
  'Albanian',
  'Algerian',
  'American',
  'American Islander',
  'American Samoan',
  'Andorran',
  'Angolan',
  'Anguillan',
  'Antiguan',
  'Argentinean',
  'Armenian',
  'Aruban',
  'Australian',
  'Austrian',
  'Azerbaijani',
  'Bahamian',
  'Bahraini',
  'Bangladeshi',
  'Barbadian',
  'Barbudans',
  'Batswana',
  'Belarusian',
  'Belgian',
  'Belizean',
  'Beninese',
  'Bermudian',
  'Bhutanese',
  'BIOT',
  'Bolivian',
  'Bonaire',
  'Bosnian',
  'Bouvet Islander',
  'Brazilian',
  'British Virgin Islander',
  'Bruneian',
  'Bulgarian',
  'Burkinabe',
  'Burmese',
  'Burundian',
  'Cambodian',
  'Cameroonian',
  'Canadian',
  'CapeVerdean',
  'Cayman Islander',
  'Central African',
  'Chadian',
  'Channel Islander',
  'Chilean',
  'Chinese',
  'Christmas Islander',
  'Cocos Islander',
  'Colombian',
  'Comoran',
  'Congolese',
  'Cook Islander',
  'Costa Rican',
  'Croatian',
  'Cuban',
  'Cypriot',
  'Czech',
  'Danish',
  'Djibouti',
  'Dominican',
  'Dutch',
  'Dutchman',
  'Dutchwoman',
  'East Timorese',
  'Ecuadorean',
  'Egyptian',
  'Emirian',
  'Equatorial Guinean',
  'Eritrean',
  'Estonian',
  'Ethiopian',
  'Falkland Islander',
  'Faroe Islander',
  'Fijian',
  'Filipino',
  'Finnish',
  'French',
  'French Guianan',
  'French Polynesian',
  'French Southern Territories',
  'Gabonese',
  'Gambian',
  'Georgian',
  'German',
  'Ghanaian',
  'Gibraltarian',
  'Greek',
  'Greenlandic',
  'Grenadian',
  'Guadeloupean',
  'Guamanian',
  'Guatemalan',
  'Guinea Bissauan',
  'Guinean',
  'Guyanese',
  'Haitian',
  'Heard Islander or McDonald Islander',
  'Herzegovinian',
  'Honduran',
  'Hongkongers',
  'Hungarian',
  'IKiribati',
  'Icelander',
  'Indian',
  'Indonesian',
  'Iranian',
  'Iraqi',
  'Israeli',
  'Italian',
  'Ivorian',
  'Jamaican',
  'Japanese',
  'Jordanian',
  'Kazakhstani',
  'Kenyan',
  'Kittian and Nevisian',
  'Kosovan',
  'Kuwaiti',
  'Kyrgyz',
  'Laotian',
  'Latvian',
  'Lebanese',
  'Liberian',
  'Libyan',
  'Liechtensteiner',
  'Lithuanian',
  'Luxembourger',
  'Macanese',
  'Macedonian',
  'Mahoran',
  'Malagasy',
  'Malawian',
  'Malaysian',
  'Maldivan',
  'Malian',
  'Maltese',
  'Manx',
  'Marshallese',
  'Martiniquais',
  'Mauritanian',
  'Mauritian',
  'Mexican',
  'Micronesian',
  'Moldovan',
  'Monacan',
  'Mongolian',
  'Montenegrin',
  'Montserratian',
  'Moroccan',
  'Mosotho',
  'Motswana',
  'Mozambican',
  'Namibian',
  'Nauruan',
  'Nepalese',
  'Netherlander',
  'New Caledonian',
  'New Zealander',
  'Ni Vanuatu',
  'Nicaraguan',
  'Nigerian',
  'Nigerien',
  'Niuean',
  'Norfolk Islander',
  'North Korean',
  'Northern Marianan',
  'Norwegian',
  'Omani',
  'Pakistani',
  'Palauan',
  'Palestinian',
  'Panamanian',
  'Papua New Guinean',
  'Paraguayan',
  'Peruvian',
  'Pitcairn Islander',
  'Polish',
  'Portuguese',
  'Puerto Rican',
  'Qatari',
  'Romanian',
  'Russian',
  'Rwandan',
  'Sahrawi',
  'Saint Helenian',
  'Saint Lucian',
  'Saint Vincentian',
  'Saint Pierrais',
  'Salvadoran',
  'Samoan',
  'San Marinese',
  'São Tomean',
  'Saudi',
  'Scottish',
  'Senegalese',
  'Serbian',
  'Seychellois',
  'Sierra Leonean',
  'Singaporean',
  'Sint Maartener',
  'Slovak',
  'Slovenian',
  'Solomon Islander',
  'Somali',
  'South African',
  'South Georgian',
  'South Korean',
  'South Sudanese',
  'Spanish',
  'Sri Lankan',
  'Sudanese',
  'Surinamer',
  'Svalbard',
  'Swazi',
  'Swedish',
  'Swiss',
  'Syrian',
  'Taiwanese',
  'Tajik',
  'Tanzanian',
  'Thai',
  'Togolese',
  'Tokelauan',
  'Tongan',
  'Trinidadian and Tobagonian',
  'Tunisian',
  'Turkish',
  'Turkmen',
  'Turks and Caicos Islander',
  'Tuvaluan',
  'US Virgin Islander',
  'Ugandan',
  'Ukrainian',
  'Uruguayan',
  'Uzbekistani',
  'Vatican',
  'Venezuelan',
  'Vietnamese',
  'Wallisian',
  'Welsh',
  'Yemenite',
  'Zambian',
  'Zimbabwean',
];

const numberOfDependantsOptions = [
  {
    label: 'Select number of dependants',
    value: SELECT_PLACEHOLDER_VALUE,
  },
  '0',
  '1',
  '2',
  '3',
  '4',
];

const titleOptions = [
  {
    label: 'Select title',
    value: clearableRequiredFieldsDefaultValuesPersonalDetails.title,
  },
  'Mr.',
  'Mrs.',
  'Ms.',
  'Miss',
];

const genderOptions = [
  {
    label: 'Select gender',
    value: clearableRequiredFieldsDefaultValuesPersonalDetails.gender,
  },
  'Male',
  'Female',
];

const maritalStatusOptions = [
  {
    label: 'Select marital status',
    value: clearableRequiredFieldsDefaultValuesPersonalDetails.maritalStatus,
  },
  'Single',
  'Married',
  'Separated',
  'Divorced',
  'Widowed',
];

export {
  countryOptions,
  numberOfDependantsOptions,
  titleOptions,
  genderOptions,
  maritalStatusOptions,
};
